"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMaxContentSize = void 0;
const getMaxContentSize = (columnId, root) => {
    return new Promise((resolve, reject) => {
        if (!root.current) {
            return reject(new Error(`Root is empty: ${root}`));
        }
        const elements = root.current.querySelectorAll(`[data-column-id="${columnId}"]`);
        if (elements.length === 0) {
            return reject(new Error(`No elements found for columnId: ${columnId}`));
        }
        const container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.visibility = 'hidden';
        container.style.display = 'inline-flex';
        container.style.flexDirection = 'column';
        document.body.appendChild(container);
        elements.forEach((element) => {
            const clone = element.cloneNode(true);
            container.appendChild(clone);
        });
        let maxWidth = 0;
        Array.from(container.children).forEach((child) => {
            const width = child.getBoundingClientRect().width;
            maxWidth = Math.max(maxWidth, width);
        });
        document.body.removeChild(container);
        resolve(maxWidth);
    });
};
exports.getMaxContentSize = getMaxContentSize;
//# sourceMappingURL=getMaxContentSize.js.map